const MSG_TAIL_SIZE = 6;    // 报文尾大小
const MSG_ETX = 0xDE;       //结束位

const NotifyMsgTail = function(opts = {}) {
    this.checkSum   = opts.checkSum   || 0;        // 校验和（4字节）
    this.etx        = opts.etx        || MSG_ETX;  // 结束位（2字节）
};

NotifyMsgTail.MSG_TAIL_SIZE   = MSG_TAIL_SIZE;
NotifyMsgTail.MSG_ETX         = MSG_ETX;

const pt = NotifyMsgTail.prototype;

// 写入数据块
pt.writeTail = function(writer) {
    writer.writeInt32(this.checkSum);
    writer.writeInt16(this.etx);
};

pt.readTail = function (reader) {
    let tail = this;
    tail.checkSum = reader.readInt32();
    tail.etx = reader.readInt16();
};

NotifyMsgTail.parseFromReader = function (reader) {
    var tail = new NotifyMsgTail();
    tail.readTail(reader);
    return tail;
};

export default NotifyMsgTail;
